module.exports = __webpack_public_path__ + "static/soccer-stadium.3d69d342.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/PageDecEvent/images/soccer-stadium.jpg
// module id = 733
// module chunks = 89027509443936